import * as React from 'react';
import { useEditorContext } from 'ui-components/RichTextEditor/tiptap/editor_context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp } from '@fortawesome/pro-regular-svg-icons';
import { useLocalization } from '~/framework';
import { TiptapButton } from '../../TiptapButton';

export const AddRowBeforeButton = () => {
   const { _js } = useLocalization();
   const { editor } = useEditorContext();

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().addRowBefore().run()}
         icon={<FontAwesomeIcon icon={faArrowUp} />}
         title={_js('Add row above')}
         isDisabled={!editor.can().addRowBefore()}
      />
   );
};
